export default [
  'INIT',
  'REALTIME_QUESTION_ADDED',
  'REALTIME_DATA_UPDATE',
  'TOGGLE_SECONDARY_PANEL',
  'TOGGLE_QUESTIONS_MODE',
  'ON_UPLOAD_HANDOUTS_CLICK',
  ['ON_ASK_QUESTION', 'values', 'formSubmitPromise'],
  'REFETCH_LIVE_DATA',
  'POLL_ANSWERED',
  ['FETCH_LIVE_DATA_SUCCESS', 'liveData'],
  ['ON_UPLOAD_PROGRESS', 'fileName', 'percent'],
  'ON_SPEAKERS_INIT',
]
